import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClusterIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.953,18.444c0,-2.16 -1.754,-3.914 -3.914,-3.914c-2.16,0 -3.914,1.754 -3.914,3.914c0,2.16 1.754,3.914 3.914,3.914c2.16,0 3.914,-1.754 3.914,-3.914Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.875,14.254c0,-2.16 -1.754,-3.914 -3.914,-3.914c-2.16,0 -3.914,1.754 -3.914,3.914c0,2.16 1.754,3.914 3.914,3.914c2.16,0 3.914,-1.754 3.914,-3.914Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.828,5.762c0,-2.16 -1.754,-3.914 -3.914,-3.914c-2.16,0 -3.914,1.754 -3.914,3.914c0,2.16 1.754,3.914 3.914,3.914c2.16,0 3.914,-1.754 3.914,-3.914Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgClusterIcon;
